import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Pagination, Button, Input, Select} from "antd";

class HalPagination extends Component {

    constructor(props) {
        super(props);
        const initialPage = (props.HAL_page && Number.isFinite(props.HAL_page.number)) ? props.HAL_page.number + 1 : 1;
        this.state = {pageInput: initialPage};
    }

    componentDidUpdate(prevProps) {
        const prevNumber = prevProps.HAL_page && prevProps.HAL_page.number;
        const currNumber = this.props.HAL_page && this.props.HAL_page.number;
        if (currNumber !== prevNumber && Number.isFinite(currNumber)) {
            this.setState({pageInput: currNumber + 1});
        }
    }

    handlePageChange = (page, pageSize) => {
        const safePage = page && page > 0 ? page : 1;
        this.setState({pageInput: safePage});
        if (this.props.onShowSizeChange) {
            this.props.onShowSizeChange(safePage, pageSize);
        }
    }

    handlePageSizeChange = (pageSize) => {
        this.handlePageChange(1, pageSize);
    }

    handlePageInputSubmit = (pageSize, fallbackPage) => {
        const parsed = parseInt(this.state.pageInput, 10);
        const nextPage = Number.isFinite(parsed) && parsed > 0 ? parsed : fallbackPage;
        this.setState({pageInput: nextPage});
        this.handlePageChange(nextPage, pageSize);
    }

    render() {

        const {size, totalElements, number = 0} = this.props.HAL_page;
        const {elementsCount} = this.props;
        const pageSizeOptions = this.props.pageSizeOptions || [];
        const fallbackPageSize = size || parseInt(pageSizeOptions[0], 10) || 10;
        const pageSize = size || fallbackPageSize;

        const currentPage = number + 1;
        const hasTotalElements = Number.isFinite(totalElements);
        const hasNextPage = hasTotalElements ? (currentPage * pageSize) < totalElements : elementsCount >= pageSize;
        const computedTotal = hasTotalElements ? totalElements : pageSize * (currentPage + (hasNextPage ? 1 : 0));
        const disablePrev = currentPage <= 1;
        const disableNext = !hasNextPage;
        const disableFirst = disablePrev;

        if (hasTotalElements) {
            return (
                <div style={{margin: 10}}>
                    <Pagination
                        simple={false}
                        onChange={this.handlePageChange}
                        current={currentPage}
                        total={computedTotal}
                        pageSize={pageSize}
                        showTotal={hasTotalElements ? ((total, range) => `${range[0]} - ${range[1]} of ${total}`) : (() => `Pagina ${currentPage}`)}
                        showSizeChanger={true}
                        onShowSizeChange={this.handlePageChange}
                        pageSizeOptions={this.props.pageSizeOptions}
                    />
                </div>
            );
        }

        const {Option} = Select;

        return (
            <div style={{margin: 10, display: 'flex', alignItems: 'center', gap: 8}}>
                <Button
                    icon="double-left"
                    disabled={disableFirst}
                    onClick={() => this.handlePageChange(1, pageSize)}
                />
                <Button
                    icon="left"
                    disabled={disablePrev}
                    onClick={() => this.handlePageChange(currentPage - 1, pageSize)}
                />
                <span>Pagina</span>
                <Input
                    value={this.state.pageInput}
                    onChange={(e) => this.setState({pageInput: e.target.value})}
                    onPressEnter={() => this.handlePageInputSubmit(pageSize, currentPage)}
                    onBlur={() => this.handlePageInputSubmit(pageSize, currentPage)}
                    style={{width: 70}}
                />
                <Button
                    icon="right"
                    disabled={disableNext}
                    onClick={() => this.handlePageChange(currentPage + 1, pageSize)}
                />
                <span style={{marginLeft: 12}}>Per pagina</span>
                <Select
                    value={`${pageSize}`}
                    onChange={this.handlePageSizeChange}
                    style={{width: 90}}
                >
                    {pageSizeOptions.map((opt) =>
                        <Option key={opt} value={opt}>{opt}</Option>
                    )}
                </Select>
            </div>
        );
    }
}

HalPagination.propTypes = {
    HAL_page: PropTypes.object.isRequired,
    onShowSizeChange: PropTypes.func,
    onChange: PropTypes.func,
    pageSizeOptions: PropTypes.array,
    elementsCount: PropTypes.number
};

HalPagination.defaultProps = {
    pageSizeOptions: ['10', '20', '30', '50', '100'],
    elementsCount: 0
};


export default HalPagination;
